import { isCsvFile } from './isCsvFile';
import { parseBulkAssetCsv } from './parseBulkAssetCsv';

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_ASSET_ROWS = 50000;

export type BulkAssetFileError =
  | 'INVALID_TYPE'
  | 'INVALID_CSV'
  | 'TOO_LARGE'
  | 'EMPTY'
  | 'TOO_MANY_ROWS'
  | 'EMPTY_VINS';

export const validateBulkAssetFile = async (
  file: File,
): Promise<BulkAssetFileError | null> => {
  if (!isCsvFile(file)) return 'INVALID_TYPE';
  if (file.size > MAX_FILE_SIZE_BYTES) return 'TOO_LARGE';

  let rows: Awaited<ReturnType<typeof parseBulkAssetCsv>>;
  try {
    rows = await parseBulkAssetCsv(file, {
      includeRowsMissingVin: true,
    });
  } catch {
    return 'INVALID_CSV';
  }
  if (rows.length === 0) return 'EMPTY';
  if (rows.length > MAX_ASSET_ROWS) return 'TOO_MANY_ROWS';
  if (rows.every((row) => !row.vin)) return 'EMPTY_VINS';

  return null;
};
